import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
    getFieldGroups,
    selectFieldGroup,
    addFieldToGroup,
    deleteFieldFromGroup,
    addUserToGroup,
    deleteUserFromGroup,
    deleteFieldGroup
} from '../store/actions/fieldGroupsActions';
import { getAllFields } from '../store/actions/fieldsActions';
import { getUsers } from '../store/actions/usersActions';
import { toggleModal } from '../store/actions/toggleModalActions';
import  './FieldGroups.scss';

import Spinner from "./_common/Spinner";
import List from "./_common/List";
import FieldGroupModal from "./FieldGroupModal";
import ConfirmationModal from "./_common/ConfirmationModal";

const selector = state => {
    const { language, fieldGroups, fields, users, modalState } = state;
    return {
        t: language.translator,
        pending: fieldGroups.pending,
        fieldGroups: fieldGroups.fieldGroups,
        page: fieldGroups.page,
        pageCount: fieldGroups.pageCount,
        itemsCount: fieldGroups.itemsCount,
        selected: fieldGroups.selected,
        fields: fields.fields,
        fieldsPending: fields.pending,
        users: users.allUsers,
        usersPending: users.pending,
        modalState: modalState
    }
};

const FieldGroups = () => {
    const {
        t, pending, fieldGroups, page, pageCount, itemsCount, selected, fields, fieldsPending, users, usersPending,
        modalState
    } = useSelector(selector);
    const dispatch = useDispatch();
    const [fieldFilterInput, setFieldFilterInput] = useState('');
    const [userFilterInput, setUserFilterInput] = useState('');

    useEffect(() => {
        dispatch(getFieldGroups());
        dispatch(getAllFields());
        dispatch(getUsers());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleDeleteModal = () => {
        dispatch(toggleModal(true, 'Delete field group'))
    }

    const deleteFieldGroupMethod = (id) => {
        dispatch(deleteFieldGroup(id))
        dispatch(toggleModal(false, 'Delete field group'))
    }

    return (
        <div className='fieldGroups'>
            <div className='addFieldGroupButton'>
                <span className='material-icons' onClick={() => dispatch(toggleModal(true, 'Create field group'))}>add</span>
            </div>
            <div className='fieldGroupsList'>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        scroll
                        roundTopCorners
                        items={fieldGroups}
                        page={page}
                        itemsPerPage={10}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={['Field group']}
                        columns={['name', 'delete']}
                        columnsWidths={['100%']}
                        getItemsMethod={getFieldGroups}
                        selectItemMethod={selectFieldGroup}
                        selected={selected.fieldGroup}
                        deleteColumn={2}
                        deleteMethod={toggleDeleteModal}
                    />
                }
            </div>
            <div className='fieldGroupDetails'>
                <div className='detailsListWrapper'>
                    {fieldsPending
                        ? <div className='page'>
                            <Spinner size={300}/>
                        </div>
                        : selected?.fieldGroup?.name && (
                            <div className='detailsList'>
                                <div className='detailsListTitle'>
                                    <div>{t.gettext('Fields')}</div>
                                    <div className='searchBox'>
                                        <span className="material-icons">search</span>
                                        <input
                                            type='text'
                                            onChange={e => setFieldFilterInput(e.target.value)}
                                            value={fieldFilterInput}
                                        />
                                        {fieldFilterInput && (
                                            <span
                                                className="material-icons clearFilterButton"
                                                onClick={() => setFieldFilterInput('')}
                                            >
                                                clear
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <ul className='detailsListContent'>
                                    {selected.fieldGroup.fields && fields.filter(x =>
                                        x.name.toLowerCase().includes(fieldFilterInput.toLowerCase()) &&
                                        selected.fieldGroup.fields.map(y => y.id).includes(x.id)
                                    ).map(field => (
                                        <li
                                            className={`
                                                detailsListItem 
                                                ${selected.fieldGroup.fields.map(x => x.id).includes(field.id)
                                                    ? 'detailsListItem--selected'
                                                    : ''
                                            }
                                            `}
                                            key={field.id}
                                            onClick={selected.fieldGroup.fields.map(x => x.id).includes(field.id)
                                                ? () => dispatch(deleteFieldFromGroup(selected.fieldGroup.id, field.id))
                                                : () => dispatch(addFieldToGroup(selected.fieldGroup.id, field.id))
                                            }
                                        >
                                            <div className='itemCheckbox'>
                                                {selected.fieldGroup.fields.map(x => x.id).includes(field.id) && (
                                                    <span className="material-icons">check</span>
                                                )}
                                            </div>
                                            <div className='itemLabel'>{field.name}</div>
                                        </li>
                                    ))}
                                    {selected.fieldGroup.fields && fields.filter(x =>
                                        x.name.toLowerCase().includes(fieldFilterInput.toLowerCase()) &&
                                        !selected.fieldGroup.fields.map(y => y.id).includes(x.id)
                                    ).map(field => (
                                        <li
                                            className={`
                                                detailsListItem 
                                                ${selected.fieldGroup.fields.map(x => x.id).includes(field.id)
                                                ? 'detailsListItem--selected'
                                                : ''
                                            }
                                            `}
                                            key={field.id}
                                            onClick={selected.fieldGroup.fields.map(x => x.id).includes(field.id)
                                                ? () => dispatch(deleteFieldFromGroup(selected.fieldGroup.id, field.id))
                                                : () => dispatch(addFieldToGroup(selected.fieldGroup.id, field.id))
                                            }
                                        >
                                            <div className='itemCheckbox'>
                                                {selected.fieldGroup.fields.map(x => x.id).includes(field.id) && (
                                                    <span className="material-icons">check</span>
                                                )}
                                            </div>
                                            <div className='itemLabel'>{field.name}</div>
                                        </li>
                                    ))}
                                    {!selected.fieldGroup.fields && fields.filter(x =>
                                        x.name.toLowerCase().includes(fieldFilterInput.toLowerCase())
                                    ).map(field => (
                                        <li
                                            className={'detailsListItem'}
                                            key={field.id}
                                            onClick={() => dispatch(addFieldToGroup(selected.fieldGroup.id, field.id))}
                                        >
                                            <div className='itemCheckbox'></div>
                                            <div className='itemLabel'>{field.name}</div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    }
                </div>
                <div className='detailsListWrapper'>
                    {usersPending
                        ? <div className='page'>
                            <Spinner size={300}/>
                        </div>
                        : selected?.fieldGroup?.name && (
                            <div className='detailsList'>
                                <div className='detailsListTitle'>
                                    <div>{t.gettext('Users')}</div>
                                    <div className='searchBox'>
                                        <span className="material-icons">search</span>
                                        <input
                                            type='text'
                                            onChange={e => setUserFilterInput(e.target.value)}
                                            value={userFilterInput}
                                        />
                                        {userFilterInput && (
                                            <span
                                                className="material-icons clearFilterButton"
                                                onClick={() => setUserFilterInput('')}
                                            >
                                                clear
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <ul className='detailsListContent'>
                                    {selected.fieldGroup.users && users.filter(x =>
                                        x.email.toLowerCase().includes(userFilterInput.toLowerCase()) &&
                                        selected.fieldGroup.users.map(y => y.id).includes(x.id)
                                    ).map(user => (
                                        <li
                                            className={`
                                                detailsListItem 
                                                ${selected.fieldGroup.users.map(x => x.id).includes(user.id) 
                                                    ? 'detailsListItem--selected' 
                                                    : ''
                                                }
                                            `}
                                            key={user.id}
                                            onClick={selected.fieldGroup.users.map(x => x.id).includes(user.id)
                                                ? () => dispatch(deleteUserFromGroup(selected.fieldGroup.id, user.id))
                                                : () => dispatch(addUserToGroup(selected.fieldGroup.id, user.id))
                                            }
                                        >
                                            <div className='itemCheckbox'>
                                                {selected.fieldGroup.users.map(x => x.id).includes(user.id) && (
                                                    <span className="material-icons">check</span>
                                                )}
                                            </div>
                                            <div className='itemLabel'>{user.email}</div>
                                        </li>
                                    ))}
                                    {selected.fieldGroup.users && users.filter(x =>
                                        x.email.toLowerCase().includes(userFilterInput.toLowerCase()) &&
                                        !selected.fieldGroup.users.map(y => y.id).includes(x.id)
                                    ).map(user => (
                                        <li
                                            className={`
                                                detailsListItem 
                                                ${selected.fieldGroup.users.map(x => x.id).includes(user.id)
                                                ? 'detailsListItem--selected'
                                                : ''
                                            }
                                            `}
                                            key={user.id}
                                            onClick={selected.fieldGroup.users.map(x => x.id).includes(user.id)
                                                ? () => dispatch(deleteUserFromGroup(selected.fieldGroup.id, user.id))
                                                : () => dispatch(addUserToGroup(selected.fieldGroup.id, user.id))
                                            }
                                        >
                                            <div className='itemCheckbox'>
                                                {selected.fieldGroup.users.map(x => x.id).includes(user.id) && (
                                                    <span className="material-icons">check</span>
                                                )}
                                            </div>
                                            <div className='itemLabel'>{user.email}</div>
                                        </li>
                                    ))}
                                    {!selected.fieldGroup.users && users.filter(x =>
                                        x.email.toLowerCase().includes(userFilterInput.toLowerCase())
                                    ).map(user => (
                                        <li
                                            className={'detailsListItem'}
                                            key={user.id}
                                            onClick={() => dispatch(addUserToGroup(selected.fieldGroup.id, user.id))}
                                        >
                                            <div className='itemCheckbox'></div>
                                            <div className='itemLabel'>{user.email}</div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    }
                </div>
            </div>

            {(modalState.flag && modalState.modal === 'Create field group') &&
                <FieldGroupModal />
            }
            {(modalState.flag && modalState.modal === 'Delete field group') &&
                <ConfirmationModal
                    text={'Do you want to delete'}
                    deleteModal
                    item={selected.fieldGroup}
                    closeMethod={() =>  dispatch(toggleModal(false, 'Delete field group'))}
                    confirmMethod={() => deleteFieldGroupMethod(selected.fieldGroup.id)}
                    confirmButtonText={'Delete'}
                />
            }
        </div>
    );
};

export default FieldGroups;
